import React from 'react'
import ReportQuestion from '../../../components/organisms/admin/report/ReportQuestion'

type Props = {}

const ReportQuestionPage = (props: Props) => {
  return (
    <ReportQuestion />
  )
}

export default ReportQuestionPage